// Define the initial state
const initialState = {
    keys: [],
    loading: false,
    error: null,
    newKey: null,
};

export default function aiRules(state = initialState, { type, payload, args, additionalPayload }) {
    switch (type) {
        case 'genAi_apiKeys_load_STARTED': {
            return {
                ...state,
                loading: true,
            };
        }
        case 'genAi_apiKeys_load_SUCCESS': {
            return {
                ...state,
                ...payload,
                loading: false,
            };
        }
        case 'genAi_apiKeys_load_ERROR': {
            return {
                ...state,
                error: payload,
                loading: false,
            };
        }
        case 'genAi_apiKeys_generate_STARTED': {
            return {
                ...state,
                loading: true,
            };
        }
        case 'genAi_apiKeys_generate_SUCCESS': {
            // set a 30s timer to clear the new key
            return {
                ...state,
                newKey: payload.realKey,
                loading: false,
            };
        }
        case 'genAi_apiKeys_generate_CLEAR': {
            return {
                ...state,
                newKey: null,
            };
        }
        case 'genAi_apiKeys_generate_ERROR': {
            return {
                ...state,
                error: payload,
                loading: false,
            };
        }

        // Removing an API key cases
        case 'genAi_apiKeys_remove_STARTED': {
            return {
                ...state,
                loading: true,
            };
        }
        case 'genAi_apiKeys_remove_SUCCESS': {
            return {
                ...state,
                // keys: state.keys.filter(key => key.id !== payload.id),
                loading: false,
            };
        }
        case 'genAi_apiKeys_remove_ERROR': {
            return {
                ...state,
                error: payload,
                loading: false,
            };
        }
        default:
            return state;
    }
};
